/**
 * This Slice manages data related to the Salesforce Data Cloud Profile API.
 */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ProfileMetadataResponse } from '../../../server/datacloud/types';

export interface ProfileState {
    metadata: ProfileMetadataResponse | null;
    metadataStatus: string;
}

const initialState: ProfileState = {
    metadata: null,
    metadataStatus: 'idle',
};

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchProfileMetadata.pending, (state, action) => {
                state.metadataStatus = 'loading';
            })
            .addCase(fetchProfileMetadata.fulfilled, (state, action) => {
                state.metadataStatus = 'succeeded';
                state.metadata = action.payload;
            })
            .addCase(fetchProfileMetadata.rejected, (state, action) => {
                state.metadataStatus = 'failed';
            });
    },
});

export const {} = profileSlice.actions;

export const fetchProfileMetadata = createAsyncThunk(
    'profile/fetchMetadata',
    async () => {
        const response = await fetch('/datacloud/profile/fetchMetadata');
        return await response.json();
    },
);
